function ErrorPage() {

    return (
        <p>I don't have a clue what you are looking for, but what you have found is an error. Good Job.</p>
    )

}

export default ErrorPage;